import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  FACTOREDINVOICE_DEDUCTIONS_LIST_ERROR,
  FACTOREDINVOICE_DEDUCTIONS_LIST_LOADING,
  FACTOREDINVOICE_DEDUCTIONS_LIST_SUCCESS,
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: []
};

function error(error) {
  return {type: FACTOREDINVOICE_DEDUCTIONS_LIST_ERROR, error};
}

function loading(loading) {
  return {type: FACTOREDINVOICE_DEDUCTIONS_LIST_LOADING, loading};
}

function success(items) {
  return {type: FACTOREDINVOICE_DEDUCTIONS_LIST_SUCCESS, items};
}


const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
};

const actions = {
    getItems({ commit, state }, factoredInvoicesId) {
      commit(loading(true));
      commit(error(null));
      const page = '/factored_invoices/' + factoredInvoicesId + '/deductions'

      return http.fetch(page)
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    }
};

const mutations = {
    [FACTOREDINVOICE_DEDUCTIONS_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [FACTOREDINVOICE_DEDUCTIONS_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [FACTOREDINVOICE_DEDUCTIONS_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/factoredinvoice/deductions-list.js